import { useEffect, useMemo } from 'react';
import { StyleSheet } from 'react-native';

import { FilterChipList } from '@/components/FilterChipList';
import { ds } from '@/components/lib/design.system';

import { useLeaguesWithLiveEvents } from '../hooks/use-leagues-with-live-events';

type LeagueFiltersProps = {
    setSelectedLeagueId: (leagueId: string) => void;
    selectedLeagueId: string | null;
};

export const LeagueFilters = ({ setSelectedLeagueId, selectedLeagueId }: LeagueFiltersProps) => {
    const leagueWithLiveEvents = useLeaguesWithLiveEvents();

    useEffect(() => {
        if (selectedLeagueId === null && leagueWithLiveEvents.length > 0) {
            setSelectedLeagueId(leagueWithLiveEvents[0]?.id);
        }
    }, [leagueWithLiveEvents, setSelectedLeagueId, selectedLeagueId]);

    const items = useMemo(
        () => leagueWithLiveEvents.map(league => ({ id: league.id, label: league.name })),
        [leagueWithLiveEvents]
    );

    return (
        <FilterChipList
            items={items}
            selected={selectedLeagueId ?? ''}
            onSelect={setSelectedLeagueId}
            contentContainerStyle={styles.container}
        />
    );
};

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 16,
        paddingBottom: 16,
        backgroundColor: ds.colorValue.background.neutral.base,
    },
});
